import { useAccount } from '@lib/context/account-context'
import { useMobileMenu } from '@lib/context/mobile-menu-context'
import ChevronDown from '@modules/common/icons/chevron-down'
import Search from '@modules/common/icons/search'
import X from '@modules/common/icons/x'
import { useCollections, useMeCustomer } from 'medusa-react'
import Link from 'next/link'
import Image from 'next/image'
import logoRect from '/public/images/logo-rect.png'
import BHRequireAccount from '@modules/account/components/require-account'
import { bhEnv } from '@lib/env'

const MainMenu = () => {
  const { collections } = useCollections()
  const { customer } = useMeCustomer()
  const { handleLogout } = useAccount()

  const {
    close,
    screen: [_, setScreen],
  } = useMobileMenu()

  const setScreenSearch = () => setScreen('search')

  const logout = () => {
    close()
    handleLogout()
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="flex items-center justify-between w-full border-b border-gray-200 py-4 px-6">
        <div className="flex-1 basis-0">
          <Image
            src={logoRect}
            layout="fixed"
            width={108}
            height={108 * (logoRect.height / logoRect.width)}
            loading="eager"
            priority={true}
            quality={90}
            objectFit="contain"
            objectPosition="center"
            alt="innovation from experience"
            draggable="false"
          />
        </div>
        <div className="flex-1 basis-0 flex justify-end">
          <button onClick={close}>
            <X size={20} />
          </button>
        </div>
      </div>

      <div className="space-y-6 flex-1 flex flex-col justify-between p-6">
        {process.env.FEATURE_SEARCH_ENABLED && (
          <button
            className="bg-gray-50 flex items-center px-4 py-2 gap-x-2 text-gray-500"
            onClick={setScreenSearch}
          >
            <Search size={24} />
            <span placeholder="Search products" className="text-base-regular">
              Search products
            </span>
          </button>
        )}

        <div className="flex flex-col flex-1 text-large-regular text-gray-900">
          <ul className="flex flex-col gap-y-2">

            <li className="bg-gray-50 p-4">

              <Link href={`${bhEnv.bhMarketingHome}`} passHref>
                <a>
                  <button
                    className="flex items-center justify-between w-full"
                    onClick={close}
                  >
                    <span className="sr-only">Barnhill Supply Home</span>
                    <span>Home</span>
                    <ChevronDown className="-rotate-90" />
                  </button>
                </a>
              </Link>
            </li>


            <BHRequireAccount>
              <li className="bg-gray-50 p-4">
                <Link href="/quotes">
                  <a>
                    <button
                      className="flex items-center justify-between w-full"
                      onClick={close}
                    >
                      <span className="sr-only">Go to Quotes</span>
                      <span>Quotes</span>
                      <ChevronDown className="-rotate-90" />
                    </button>
                  </a>
                </Link>
              </li>
            </BHRequireAccount>
            <li className="bg-gray-50 p-4">
              <Link href="/store">
                <a>
                  <button
                    className="flex items-center justify-between w-full"
                    onClick={close}
                  >
                    <span className="sr-only">Go to Store</span>
                    <span>Store</span>
                    <ChevronDown className="-rotate-90" />
                  </button>
                </a>
              </Link>
            </li>

            {/* <li className="bg-gray-50 p-4">
              <Link href="/about">
                <a>
                  <button
                    className="flex items-center justify-between w-full"
                    onClick={close}
                  >
                    <span className="sr-only">Go to About Us</span>
                    <span>About</span>
                    <ChevronDown className="-rotate-90" />
                  </button>
                </a>
              </Link>
            </li> */}
            {collections ? (
              <>
                {collections.map((collection) => (
                  <li key={collection.id} className="bg-gray-50 p-4">
                    <Link href={`/collections/${collection.id}`}>
                      <a>
                        <button
                          className="flex items-center justify-between w-full"
                          onClick={close}
                        >
                          <span className="sr-only">
                            Go to {collection.title} collection
                          </span>
                          <span>{collection.title}</span>
                          <ChevronDown className="-rotate-90" />
                        </button>
                      </a>
                    </Link>
                  </li>
                ))}
              </>
            ) : null}
          </ul>
        </div>

        <div className="flex flex-col">
          <div className="flex flex-col gap-y-8 text-small-regular">
            {!customer ? (
              <div className="flex flex-col gap-y-4">
                <span className="text-gray-700 uppercase">Account</span>
                <Link href={`/account/login`} passHref>
                  <a>
                    <button
                      className="flex items-center justify-between border-b border-gray-200 py-2 w-full"
                      onClick={close}
                    >
                      <span className="sr-only">Go to sign in page</span>
                      <span className="normal-case">Sign in</span>
                      <ChevronDown className="-rotate-90" />
                    </button>
                  </a>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col gap-y-4">
                <span className="text-gray-700 uppercase">Signed in as</span>
                <Link href={`/account`} passHref>
                  <a>
                    <button
                      className="flex items-center justify-between border-b border-gray-200 py-2 w-full"
                      onClick={close}
                    >
                      <span className="sr-only">Go to account page</span>
                      <span className="normal-case">{customer.email}</span>
                      <ChevronDown className="-rotate-90" />
                    </button>
                  </a>
                </Link>
                <button
                  type="button"
                  className="flex items-center justify-between border-b border-gray-200 py-2 w-full text-gray-700"
                  onClick={logout}
                >
                  <span className="normal-case">Log out</span>
                  <ChevronDown className="-rotate-90" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainMenu
